import { copilotRepository } from '@/service/repository/copilotRepository';
import store from '@/store';

export class WalkingService {
	constructor() {}

	async create(data) {
		// if (!data.staffId) {
		// 	data.staffId = store.state['copilot/currentStaff'].id;
		// }
		let createWalkInResult = await copilotRepository.createWalkin(data);

		if (createWalkInResult.result === 0) {
			let reservation = createWalkInResult.reservation;
			store.commit('reservation/setReservation', reservation);
			store.commit('copilot/setCommanderReservation', { commanderReservation: reservation });
			if (store.getters['copilot/view'] !== 'TPV') {
				// this._openQRInvitation(reservation.id)
				// store.dispatch("uiOverlay/setIsShowOverlayQRAccount", true);
				store.dispatch('uiOverlay/setIsShowOverlayCommander', true);
			}
		}

		return createWalkInResult;
	}

	async createKiosk(data) {
		let createWalkInResult = await copilotRepository.createKioskoWalkin(data);

		if (createWalkInResult.result === 0) {
			let reservation = createWalkInResult.reservation;
			store.commit('reservation/setReservation', reservation);

			this._openQRInvitation(reservation.id);
		}

		return createWalkInResult;
	}

	_openQRInvitation(reservationId) {
		const reservationElementId = 'reservation-' + reservationId;

		let reservationElement = document.getElementById(reservationElementId);

		if (reservationElement) {
			this._showQrModal(reservationId, reservationElementId);
			return;
		}

		const observer = new MutationObserver((mutationsList, observer) => {
			reservationElement = document.getElementById(reservationElementId);

			if (reservationElement) {
				observer.disconnect(); // Stop observing once the element is found
				this._showQrModal(reservationId, reservationElementId);
			}
		});

		observer.observe(document.body, { childList: true, subtree: true });

		setTimeout(() => {
			observer.disconnect();
			reservationElement = document.getElementById(reservationElementId);
			if (!reservationElement) {
				console.log(`Reservation element for reservation ${reservationId} was not found after 3 seconds.`);
			}
		}, 3000);
	}

	_showQrModal(reservationId, reservationElementId) {
		const reservationElement = document.getElementById(reservationElementId);

		// Buscar el accordion padre usando el elemento de reservación
		const parentAccordion = reservationElement?.closest('[data-bs-parent="#accordionAllServices"]');

		if (parentAccordion && !parentAccordion.classList.contains('show')) {
			parentAccordion.classList.add('show');
		}

		if (reservationElement) {
			window.scrollTo({
				top: reservationElement.offsetTop,
				behavior: 'smooth',
			});
		} else {
			console.error(`Reservation element with ID '${reservationElementId}' not found.`);
		}

		// setTimeout(() => {
		// 	showModal("modalQr" + reservationId);
		// }, 0);
		store.dispatch('uiOverlay/setIsShowOverlayQRAccount', true);
	}
}

export const walkingService = new WalkingService();
